export default "__VITE_ASSET__Cahfpcjn__"